import type { AssetApiClient } from "@skilitics/asset-register-api-client";
import { createClient } from "@skilitics/asset-register-api-client";

import { getRequiredAppSetting } from "../shared/index.ts";
import { attachAuthorizationMiddleware } from "./infrastructure/index.ts";

const endpoint = getRequiredAppSetting(import.meta.env.REACT_APP_ASSET_REGISTER_ENDPOINT, "ASSET_REGISTER_ENDPOINT");
const client = createClient(endpoint);
attachAuthorizationMiddleware(client.axios);

export const useAssetApi = (): AssetApiClient => client;
